import { Navigate, Outlet, useLocation } from 'react-router-dom';

import AppDataBootstrap from 'src/components/gates/AppDataBootstrap';
import { useStore } from 'src/hooks/useStore';
import { RoutePaths } from 'src/utils/enums';

const ProtectedRoutes = (): JSX.Element => {
  const { authStore } = useStore();
  const location = useLocation();

  if (!authStore.isAuthenticated) {
    authStore.logOut();
    return <Navigate to={RoutePaths.SignIn} state={{ from: location.pathname }} />;
  }

  return (
    <AppDataBootstrap>
      <Outlet />
    </AppDataBootstrap>
  );
};

export default ProtectedRoutes;
